<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import { computed, onMounted, ref, watch } from 'vue'
import translaters from '../../tradutors/assine';
import { localeStore } from '../../stores/locale'
import { planStore } from '../../stores/plans'
import { userStore } from "../../stores/user";
import { planCreditStore } from '../../stores/planscredits'
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'
import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
import AssinePlans from "../../components/Assine/AssinePlans.vue";
import AssineCredits from "../../components/Assine/AssineCredits.vue";
import { isMobile } from "../shared/utils/mobile";

const storeLocale = localeStore()
const storePlan = planStore()
const storePlanCredits = planCreditStore()
const storeUser = userStore()
const route = useRoute()

const selectedTab = ref("0")

const plans = ref([])
const plansCredits = ref([])

const reactivePlans = computed(() => storePlan.plans) 
const reactivePlansCredits = computed(() => storePlanCredits.plansCredits) 
const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref
const reactiveVoucher = computed(() => storePlan.voucher)
const isActiveUser = computed(() => storeUser.isActiveUser)

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

watch(reactivePlans, () => {
    getPlans()
})

watch(reactivePlansCredits, () => {
    getPlansCredits()
})

onMounted(() => {
    getPlans()
    getPlansCredits()
})

useHead({
    templateParams: {
    subTitle: null, 
        subPage: reactiveLocale.value == 'pt-br' ? 'Assine' : 'Subscribe Now',
        page_url: window.location.origin + route.fullPath,
        page_description:
        reactiveLocale.value == 'pt-br'
            ? `Quer ver tudo sem censura? Assine agora e tenha acesso ao conteúdo VIP`
            : `Want to see everything uncensored? Subscribe now and get access to VIP content`,
        page_image: '/favicon.ico',
        page_keywords:
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: reactiveLocale.value,
        page_url_pt: 'https://belladasemana.com.br/pt-br/assine',
        page_url_en: 'https://belladasemana.com.br/en/assine',
        page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
})

async function getPlans() {
    const voucher = route.query.voucher || reactiveVoucher.value || ''
    if (voucher && !isActiveUser.value) {
        let arr = Object.values(reactivePlans.value)
        let x = 2;
        let pos = 1;
        let temp = arr[x];
        let i;
        for (i = x; i >= pos; i--) {
            arr[i] = arr[i - 1];
        }
        arr[pos] = temp;            
        plans.value = arr
    } else {
        plans.value = Object.values(reactivePlans.value).reverse()
    }
}

async function getPlansCredits() {
    plansCredits.value = reactivePlansCredits.value
    if (parseInt(reactivePlansCredits.value[0]?.discount_value) > 0 || isActiveUser.value || route.query.redirectCredits) {
        setTimeout(() => {
            selectedTab.value = "1"
        }, 500)
    }
}
</script>

<template>
    <MainLayout #="{ showModalMessages }">
        <div class="slot-body"> 
            <div class="container col-lg-10 col-12 d-flex" >
                <div class="breadcrumb breadcrumb2">{{ translate.breadcrumb1 }}</div>
                <div class="breadcrumb">></div>
                <div class="breadcrumb">{{ isMobile() ? translate.breadcrumbMobile2 : translate.breadcrumb2 }}</div>
                <div class="breadcrumb">></div>
                <div class="breadcrumb">{{ isMobile() ? translate.breadcrumbMobile3 : translate.breadcrumb3 }}</div>
                <div class="breadcrumb">></div>                
                <div class="breadcrumb">{{ translate.breadcrumb4 }}</div>
            </div>
            <div class="container pt-5 pb-4 assine-header-mobile" v-if="isMobile()">
                <div class="header1">{{ translate.header }}</div>
                <div class="header2 pt-3">{{ translate.title }}</div>
                <div class="header3 pt-2">{{ translate.subTitle }}</div>                                
            </div>
            <div class="container py-5">
                <tabs v-model="selectedTab">
                    <tab
                        key="0"
                        val="0"
                        :label="translate.assineOptions1"
                        :indicator="true"
                    />
                    <tab
                        key="1"
                        val="1"
                        :label="translate.assineOptions2"
                        :indicator="true"
                    />
                </tabs>
                <tab-panels v-model="selectedTab" :animate="true">
                    <tab-panel key="0" val="0">
                        <AssinePlans v-if="plans && +selectedTab == 0" :plans="plans" />
                    </tab-panel>
                    <tab-panel key="1" val="1">
                        <AssineCredits v-if="plansCredits && +selectedTab == 1" :plansCredits="plansCredits" @showModalMessages="showModalMessages"/>
                    </tab-panel>
                </tab-panels>
            </div>
        </div>
    </MainLayout>    
</template>

<style scoped lang="css">
.slot-body {
    margin-top: 65px !important;    
    background-color: #fff;    
}

.tabs {
    border: 1px solid #b5b5b5;
    border-radius: 25px;
    justify-content: center;
    width: 31%;
    font-family: 'Exo 2';
    font-weight: 600;
    font-size: 14px;
    line-height: 16.8px;
    color: #979797;
    padding-top: 8px;
    padding-bottom: 9px;
    left: 50%;
    transform: translate(-50%) !important;
}

.tabs > .active {
    border: 0px;
    background-color: #333333;
    color: #ffffff;
    border-radius: 25px;
    height: 34px;
}

.tabs >>> .tab {
    cursor: pointer;
    padding: 8px 17px;
}

.assine-header-mobile {
    background-color: #f8f8f8;
    padding-left: 20px;
}

.header1 {
    font-family: 'Bebas-Neue';
    font-weight: 400;
    font-size: 32px;
    line-height: 38.4px;
    color: #5B5858;
}

.header2 {
    font-family: 'Roboto-Medium';
    font-weight: 900;
    font-size: 22px;
    line-height: 25.78px;
    color: #5B5858;
}

.header3 {
    font-family: 'Roboto-Medium';
    font-weight: 900;
    font-size: 16px;
    line-height: 18.75px;
    color: #8C8C8C;
}

.breadcrumb {
    padding: 20px 5px;
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 14px;
    line-height: 16.8px;
    color: #979797;    
    margin-bottom: unset;    
}

.breadcrumb1 {
    color: #5B5858;    
    cursor: pointer;
}

.breadcrumb2 {
    color: #5B5858;    
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
    .tabs {
        min-width: 340px;        
        font-size: 12px;        
    }       
}
</style>